import { getOffersApi } from './get-offers.config';

export const {
  getOffers,
  getOffersClear,
  getOffersError,
  getOffersSuccess,
  getOffersActions,
} = getOffersApi;
